/**
 * Personal automations, under the organization — `/$org/automations`. The
 * tenant in the URL determines which organisation's data each schedule uses.
 *
 * @module routes/$org.automations
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

import { AutomationsPage } from "../components/automations/AutomationsPage";
import { recordVisitedOrg, useActiveOrgId, useOrgs } from "../state/orgs";

function AutomationsRouteView() {
  const activeOrgId = useActiveOrgId();
  const { orgs } = useOrgs();
  useEffect(() => {
    if (activeOrgId && orgs.some((org) => org.id === activeOrgId)) {
      recordVisitedOrg(activeOrgId);
    }
  }, [activeOrgId, orgs]);
  return <AutomationsPage />;
}

export const Route = createFileRoute("/$org/automations")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: AutomationsRouteView,
});
